import type employeeId from "./id";

const employeeEn: typeof employeeId = {
	employee: {
		title: "Employee",
		subtitle: "Employee list summary",
		table_title: "Employee Data",
		empty_title: "No employee data",
		empty_description: "Please add a new employee.",
		columns: {
			created_at: "Created At",
			name: "Employee Name",
			email: "Email",
			store: "Store",
			position: "Position",
			balance: "Balance",
			status: "Status",
		},
		status: {
			active: "Active",
			inactive: "Inactive",
		},
		add: {
			button: "Add employee",
			title: "Add employee",
			description: "Add new employee data",
			success: "Success!",
			success_description: "{name} has been added!",
			error: "An error occurred!",
			error_description: "Please try again later!",
		},
		edit: {
			title: "Edit employee",
			description: "Edit employee's data",
			section_info: "Employee Information",
			section_pic: "PIC Information",
			section_settings: "Employee Settings",
			section_rounding: "Rounding Settings",
			section_footer_printer: "Footer Printer",
			saving: "Saving...",
			save: "Save Changes",
		},
		delete: {
			title: "Delete employee",
			confirm: "Are you sure you want to delete {name}?",
			button: "Delete",
		},
		form: {
			name: "Employee Name",
			email: "Email",
			email_field_description:
				"The password will be sent via email. Make sure the email you enter is VALID!",
			choose_store: "Choose store",
			choose_role: "Choose role",
			placement_and_role: "Placement & Role",
		},
		actions: {
			cancel: "Cancel",
			save: "Save",
			saving: "Saving...",
			delete: "Delete",
			deleting: "Deleting...",
		},
	},
};

export default employeeEn;
